import { render, staticRenderFns } from "./SettingsError.vue?vue&type=template&id=1c798672"
import script from "./SettingsError.vue?vue&type=script&lang=js"
export * from "./SettingsError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports